/**
 * Format: Preorder date
 * -----------------------------------------------------------------------------
 * Formats preorder dates.
 *
 */

import formatDate from '~/core/helpers/format-date'

/**
 * Formats a preorder date
 * @param {String|null} [date] - Date to format
 * @param {String|null} [dateFormat] - The format to use
 * @returns {String}
 */
export default ({
  date = null,
  dateFormat = 'preorder_cart_html',
} = {}) => {
  if (!date) {
    return ''
  }

  const dateParts = date.split('-')
  const isoDate = dateParts.length === 3
    ? `${dateParts[2]}-${dateParts[0]}-${dateParts[1]}`
    : date

  let dateObject = new Date(isoDate)
  const msOffset = dateObject.getTimezoneOffset() * 60000
  dateObject = new Date(dateObject.getTime() + msOffset)
  return formatDate(`date_formats.${dateFormat}`, dateObject)
}
